import React, { useState } from 'react';
import { useAuth } from '../../../contexts/AuthContext';
import Icon from '../../../components/AppIcon';
import { ui } from './authFieldStyles';

/**
 * Second login step for a super-admin who has 2FA enabled: enter the 6-digit TOTP code and
 * exchange the pending token for a real session.
 */
const TwoFactorPrompt = ({ pendingToken, onSuccess, onBack }) => {
  const { verifyLogin2fa } = useAuth();
  const [code, setCode] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    if (!/^\d{6}$/.test(code)) {
      setErr('Enter the 6-digit code from your authenticator app.');
      return;
    }
    setErr('');
    setLoading(true);
    const res = await verifyLogin2fa(pendingToken, code);
    setLoading(false);
    if (res.success) onSuccess();
    else setErr(res.error || 'Invalid code. Please try again.');
  };

  return (
    <div style={ui.card}>
      <h1 style={ui.heading}>Two-factor authentication</h1>
      <p style={ui.sub}>Enter the 6-digit code from your authenticator app to finish signing in.</p>
      <form onSubmit={submit} noValidate>
        {err && (
          <div style={ui.errBanner}>
            <Icon name="AlertCircle" size={14} color="#DC2626" />
            {err}
          </div>
        )}
        <div style={ui.field}>
          <label style={ui.label} htmlFor="totp-code">Verification code</label>
          <input
            id="totp-code"
            inputMode="numeric"
            autoComplete="one-time-code"
            maxLength={6}
            value={code}
            onChange={(e) => { setCode(e.target.value.replace(/\D/g, '').slice(0, 6)); if (err) setErr(''); }}
            placeholder="000000"
            autoFocus
            disabled={loading}
            style={{ ...ui.input, ...ui.codeInput, ...(err ? ui.inputErr : {}) }}
          />
        </div>
        <button type="submit" disabled={loading} style={{ ...ui.cta, ...(loading ? ui.ctaDisabled : {}) }}>
          {loading ? 'Verifying…' : 'Verify & sign in'}
        </button>
        <button type="button" onClick={onBack} disabled={loading} style={ui.secondaryBtn}>
          Back to login
        </button>
      </form>
    </div>
  );
};

export default TwoFactorPrompt;
